<div
  class="floating-inspector"
  *ngIf="visible$ | async"
  [style.left.px]="inspectorPosition?.x"
  [style.top.px]="inspectorPosition?.y"
  [style.width.px]="inspectorPosition?.width"
  [style.max-height.px]="inspectorPosition?.height"
  [class.dragging]="isDragging"
  [class.resizing]="isResizing"
  #inspectorPanel>
  
  <!-- Cabeçalho do Inspetor -->
  <div class="inspector-header" (mousedown)="onStartDrag($event)">
    <div class="header-content">
      <nz-icon nzType="drag" nzTheme="outline" class="drag-handle"></nz-icon>
      <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
      <span class="header-title">{{ 'builderScreen.inspector.title' |translateTA }}</span>
      <div class="header-component-type" *ngIf="currentComponent$ | async as component">
        <nz-tag [nzColor]="'blue'">{{ component.type | titlecase }}</nz-tag>
      </div>
    </div>
    
    <div class="header-actions">
      <!-- Botão de debug para testar funcionalidade de presets -->
      <button nz-button nzType="text" nzSize="small" (click)="testPresetFunctionality()" [nz-tooltip]="'builderScreen.presets.test' | translateTA">
        🧪
      </button>
      <button nz-button nzType="text" nzSize="small" (click)="onCloseInspector($event)" nz-tooltip="{{ 'builderScreen.inspector.close' |translateTA }}">
        <nz-icon nzType="close" nzTheme="outline"></nz-icon>
      </button>
    </div>
  </div>

  

  <!-- Seletor de Preset de Painel -->
  <app-panel-preset-selector
    [componentType]="(currentComponent$ | async)?.type || null"
    [compact]="true"
    (presetSelected)="onPresetSelected($event)">
  </app-panel-preset-selector>

  <!-- Painel de Sugestões Inteligentes -->
  <app-smart-suggestions-panel
    [componentType]="(selectedComponent$ | async)?.type || null"
    [compact]="true">
  </app-smart-suggestions-panel>

  <!-- Guia Simples para Usuários Não Técnicos -->
  <div class="user-guide" *ngIf="showUserGuide">
    <nz-alert
      nzType="info"
      nzCloseable
      [nzMessage]="'builderScreen.inspector.guide.title' |translateTA"
      [nzDescription]="'builderScreen.inspector.guide.description' |translateTA"
      (nzOnClose)="hideUserGuide()">
    </nz-alert>
  </div>

  <!-- Barra de Busca Aprimorada -->
  <div class="inspector-search">
    <nz-input-group nzCompact>
      <input
        nz-input
        [placeholder]="'builderScreen.inspector.searchPlaceholder' |translateTA"
        [value]="searchTerm$ | async"
        (input)="onSearchChange($event.target.value)"
        style="width: 100%">
      <button nz-button nzType="primary" nzSize="small" (click)="clearSearch()" *ngIf="(searchTerm$ | async); else searchIcon">
        <nz-icon nzType="close" nzTheme="outline"></nz-icon>
      </button>
      <ng-template #searchIcon>
        <button nz-button nzType="primary" nzSize="small">
          <nz-icon nzType="search" nzTheme="outline"></nz-icon>
        </button>
      </ng-template>
    </nz-input-group>
    
    <!-- Resumo dos Resultados da Busca -->
    <div class="search-results-summary" *ngIf="searchTerm$ | async as searchTerm">
      <div class="results-info" *ngIf="getSearchResultsCount() > 0; else noResults">
        <nz-tag nzSize="small" [nzColor]="'blue'">
          <nz-icon nzType="search" nzTheme="outline"></nz-icon>
          {{ getSearchResultsCount() }} {{ 'builderScreen.inspector.search.results' |translateTA }}
        </nz-tag>
        <span class="search-term">"{{ searchTerm }}"</span>
      </div>
      <ng-template #noResults>
        <div class="no-results">
          <nz-tag nzSize="small" [nzColor]="'orange'">
            <nz-icon nzType="exclamation-circle" nzTheme="outline"></nz-icon>
            {{ 'builderScreen.inspector.search.noResults' |translateTA }}
          </nz-tag>
          <span class="search-term">"{{ searchTerm }}"</span>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Grupos de Propriedades com Chave de Re-renderização Forçada -->
  <div class="inspector-content" [attr.data-key]="inspectorKey">
    <nz-collapse nzAccordion [attr.data-inspector-key]="inspectorKey">
      <nz-collapse-panel
        *ngFor="let group of filteredGroups$ | async; trackBy: trackByGroupId"
        [nzActive]="!isGroupCollapsed(group.id)"
        [nzHeader]="group.title |translateTA"
        [nzExtra]="groupExtraTemplate"
        (nzActiveChange)="onGroupToggle(group.id)"
        [class]="'priority-' + group.priority"
        [nzDisabled]="false"
        [attr.data-group-key]="inspectorKey + '-' + group.id">
        
        <!-- Template Extra do Grupo -->
        <ng-template #groupExtraTemplate>
          <div class="group-header-extra">
            <nz-icon [nzType]="group.icon" nzTheme="outline"></nz-icon>
            <nz-badge [nzCount]="group.properties.length" [nzShowZero]="false" nzSize="small"></nz-badge>
            <button 
              nz-button 
              nzType="text" 
              nzSize="small"
              (click)="closeGroup(group.id, $event)"
              nz-tooltip="{{ 'builderScreen.inspector.closeGroup' |translateTA }}"
              class="group-close-btn">
              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
            </button>
          </div>
        </ng-template>

        <!-- Descrição do Grupo -->
        <div class="group-description" *ngIf="group.description">
          <small>{{ group.description |translateTA }}</small>
        </div>

        <!-- Controles de Propriedades -->
        <div class="property-controls">
          <div
            *ngFor="let property of group.properties; trackBy: trackByProperty"
            class="property-item">
            
            <app-property-control
              [property]="property"
              [component]="currentComponent$ | async"
              [displayName]="propertyGrouper.getPropertyDisplayName(property)"
              [description]="propertyGrouper.getPropertyDescription(property)"
              [compact]="(layoutConfig$ | async)?.compactMode || false">
            </app-property-control>
          </div>
        </div>

        <!-- Estado Vazio -->
        <div class="empty-state" *ngIf="group.properties.length === 0">
          <nz-empty
            [nzNotFoundImage]="'simple'"
            [nzNotFoundContent]="'builderScreen.inspector.noProperties' |translateTA">
          </nz-empty>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <!-- Estado Sem Resultados -->
    <div class="no-results" *ngIf="(filteredGroups$ | async)?.length === 0 && (searchTerm$ | async)">
      <nz-empty
        [nzNotFoundImage]="'simple'"
        [nzNotFoundContent]="'builderScreen.inspector.noSearchResults' |translateTA">
        <div nz-empty-footer>
          <button nz-button nzType="primary" nzSize="small" (click)="onSearchChange('')">
            {{ 'builderScreen.inspector.clearSearch' |translateTA }}
          </button>
        </div>
      </nz-empty>
    </div>
  </div>

  <!-- Rodapé do Inspetor -->
  <div class="inspector-footer">
    <div class="footer-info">
      <small *ngIf="currentComponent$ | async as component">
        ID: {{ component.id }}
      </small>
    </div>
    
    <div class="footer-actions">
      <button
        nz-button
        nzType="text"
        nzSize="small"
        nz-tooltip="{{ 'builderScreen.inspector.resetProperties' |translateTA }}"
        (click)="onResetProperties()">
        <nz-icon nzType="reload" nzTheme="outline"></nz-icon>
      </button>
      
      <button
        nz-button
        nzType="text"
        nzSize="small"
        nz-tooltip="{{ 'builderScreen.inspector.duplicateComponent' |translateTA }}"
        (click)="onDuplicateComponent()">
        <nz-icon nzType="copy" nzTheme="outline"></nz-icon>
      </button>
    </div>
  </div>

  <!-- Alças de Redimensionamento -->
  <div class="resize-handle resize-right" (mousedown)="onStartResize('right', $event)"></div>
  <div class="resize-handle resize-bottom" (mousedown)="onStartResize('bottom', $event)"></div>
  <div class="resize-handle resize-corner" (mousedown)="onStartResize('corner', $event)"></div>
</div>

<!-- Versão Modal para Mobile/Tablet -->
<nz-modal
  *ngIf="(layoutConfig$ | async)?.inspectorMode === 'modal'"
  [nzVisible]="visible$ | async"
  [nzTitle]="'builderScreen.inspector.title' |translateTA"
  [nzFooter]="null"
  [nzWidth]="'90vw'"
  [nzBodyStyle]="{ padding: '16px' }"
  (nzOnCancel)="onCloseInspector()"
  (nzOnOk)="onCloseInspector()">
  
  <!-- Conteúdo móvel - mesmo que desktop mas sem posicionamento -->
  <div class="inspector-content mobile">
    <!-- Barra de Busca -->
    <div class="inspector-search">
      <nz-input-group nzCompact>
        <input
          nz-input
          [placeholder]="'builderScreen.inspector.searchPlaceholder' |translateTA"
          [value]="searchTerm$ | async"
          (input)="onSearchChange($event.target.value)">
        <button nz-button nzType="primary" nzSize="small">
          <nz-icon nzType="search" nzTheme="outline"></nz-icon>
        </button>
      </nz-input-group>
    </div>

    <!-- Grupos de Propriedades - Versão Mobile -->
    <nz-collapse nzAccordion>
      <nz-collapse-panel
        *ngFor="let group of filteredGroups$ | async; trackBy: trackByGroupId"
        [nzActive]="group.autoExpand"
        [nzHeader]="group.title">
        
        <div class="property-controls mobile">
          <div
            *ngFor="let property of group.properties; trackBy: trackByProperty"
            class="property-item">
            
            <app-property-control
              [property]="property"
              [component]="currentComponent$ | async"
              [displayName]="propertyGrouper.getPropertyDisplayName(property)"
              [description]="propertyGrouper.getPropertyDescription(property)"
              [compact]="true">
            </app-property-control>
          </div>
        </div>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
</nz-modal>
